import { render, staticRenderFns } from "./WChip.vue?vue&type=template&id=ec52f458&scoped=true&"
import script from "./WChip.vue?vue&type=script&lang=js&"
export * from "./WChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec52f458",
  null
  
)

export default component.exports